import { roles } from "constants/index";

export const rolesNavNoti = [roles.qs, roles.departmentManager, roles.shopManager, roles.regionManager, roles.viceRegionManager]

export const rolesNotNavTimesheet = [roles.qs, roles.regionManager, roles.viceRegionManager]

export const rolesNavListEmployee = [roles.admin, roles.departmentManager, roles.areaManager, roles.shopManager, roles.regionManager, roles.viceRegionManager]

export const rolesNavListShop = [roles.admin, roles.departmentManager, roles.areaManager, roles.shopManager, roles.regionManager, roles.viceRegionManager]

export const rolesIngredientSushi = [roles.admin]

export const rolesBox = [roles.admin]

export const rolesRevenue = [roles.admin, roles.departmentManager, roles.areaManager, roles.shopManager, roles.regionManager, roles.viceRegionManager]

export const rolesGrowth = [roles.admin, roles.departmentManager, roles.regionManager, roles.viceRegionManager]

export const rolesFetchCountNoti = [roles.shopManager]